import React from 'react'
import {Field, Form, Formik} from "formik"
import * as Yup from "yup"
import {useHistory} from 'react-router-dom'
import {useTranslation} from "react-i18next"
import store from "@formApp/store"
import GenericInput from "@formComponents/fields/GenericInput"
import FormError from "@formComponents/FormError"
import ConditionalRegistrantInput from "@formComponents/fields/ConditionalRegistrantInput"
import SingleDomainItem from "@formComponents/SingleDomainItem"
import LoginWith from "@formComponents/LoginWith"
import FieldTelephone from "@formComponents/fields/FieldTelephone";
import FieldNation from "@formComponents/fields/FieldNation";
import YesNoChoice from "@formComponents/fields/YesNoChoice";
import Spinner from "@formComponents/Spinner";
import Step2host from "./Step2host";

export default () => (
  <Step2host form={(initialValues, validationSchema, onSubmit) => {
  const {formValues, domainsList, transitions, loginWithWidget} = React.useContext(store);
  let history = useHistory();
  const {t} = useTranslation();
  const [typeOfUser, setTypeOfUser] = React.useState(formValues.getValue('entity') || '1');
  const selectedItem = domainsList.getSelected();
  if (!selectedItem) history.push('step-1');
  const {data, userIsConnected} = loginWithWidget;
  
  initialValues = {
    ...initialValues,
    org: formValues.getValue('org') || '',
    org_taxid: formValues.getValue('org_taxid') || '',
    nation: formValues.getValue('nation') || 'IT',
    dial_code: formValues.getValue('dial_code') || '39',
    icannTucows: formValues.getValue('icannTucows') || '',
    tucows: formValues.getValue('tucows') || '',
    icann: formValues.getValue('icann') || '',
  };
  validationSchema = {
    ...validationSchema,
    org: Yup.string().when('entity', {
      is: '2',
      then: Yup.string().required(t('no_org')),
    }),
    org_taxid: Yup.string().when('entity', {
      is: '2',
      then: Yup.string().required(t('no_org_taxid')),
    }),
    icannTucows: Yup.string().oneOf(['yes'], t('err_tos')).required(t('err_tos')),
    tucows: Yup.string().oneOf(['yes'], t('err_tos')).required(t('err_tos')),
    icann: Yup.string().oneOf(['yes'], t('err_tos')).required(t('err_tos')),
  };

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={Yup.object(validationSchema)}
      validateOnChange={false}
      validateOnBlur={true}
      onSubmit={onSubmit}
    >
      {formikProps => (
        <form className='domainRegistration' onReset={formikProps.handleReset} onSubmit={formikProps.handleSubmit}>
          <div className='transitionWrapper'>
            <div className='toTransition'>
              <section className='formSection halfColumn'>

                <div className='formSection--title'>{t('NomeDominio')}</div>
                <GenericInput name='domainName' label={initialValues.fullDomainName} disabled="disabled" />
                
                {selectedItem.transfer &&
                  <>
                    <div className='formSection--title'>{t('AuthCode')}</div>
                    <GenericInput name='authCode' label={t('AuthCode')} />
                  </>
                }
                
                <div className='formSection--title'>
                  {t('Tipo di registrante')}
                </div>
                <Field name="entity">
                  {({field, meta: { touched, error }}) => {
                    const handleChange = (e) => {
                      field.onChange(e);
                      setTypeOfUser(e.target.value);
                    };
                    return (
                        <div className={`formGroup${(touched && error) ? ' error' : ''}`}>
                          <select {...field} className='formField --select' onChange={handleChange}>
                            <option value="1">{t('Privato')}</option>
                            <option value="2">{t('Società')}</option>
                          </select>
                          {touched && error && <div className="errorMessage">{error}</div>}
                        </div>
                    )
                  }}
                </Field>
                <ConditionalRegistrantInput name='org' label={t('Ragione Sociale')} condition='2' defaultValue='' />
                <ConditionalRegistrantInput name='org_taxid' label={t('Partita IVA')} condition='2' defaultValue='' />
                <div className='formSection--title'>
                  {t('Inserisci i dati personali')}
                </div>
                <div className='formGroup' style={{gridColumn: '1 / span 2'}}>
                  <LoginWith/>
                </div>
                <GenericInput name='Nome' label={t('Nome')} />
                <GenericInput name='Cognome' label={t('Cognome')} />
                <Field name="Birth">
                  {({field, meta: { touched, error }}) => {
                    const startDate = new Date().getFullYear() - 16;
                    const endDate = new Date().getFullYear() - 110;
                    const years = [];
                    for (let year = startDate; year >= endDate; year--) {
                      years.push(<option key={year} value={year}>{year}</option>)
                    }
                    return (
                      <div className={`formGroup${(touched && error) ? ' error' : ''}`}>
                        <select {...field} className='formField --select'>
                          <option value="" disabled >{t('Anno di nascita')}</option>
                          {years}
                        </select>
                        {touched && error && <div className="errorMessage">{error}</div>}
                      </div>
                    )
                  }}
                </Field>
              </section>
              <section className='formSection halfColumn'>
                <div className='formSection--title'>{(typeOfUser === '1') ? t('Residenza e recapiti') : t('Sede legale e recapiti')}</div>
                <FieldNation />
                <GenericInput name='address' label={t('Indirizzo')} />
                <GenericInput name='zip' label={t('CAP')} />
                <GenericInput name='city' label={t('Città')} />
                <GenericInput name='prov' label={t('Provincia/Stato')} />
                <FieldTelephone />
                <GenericInput name='Email' label={t('Email')} />
                <GenericInput name='mailConfirm' label={t('Conferma Email')} />
              </section>
              <section>
                <YesNoChoice name="icannTucows" title='domain_srs_tos_tucows' />
                <YesNoChoice name="tucows" title='domain_srs_tos_tucows_privacy' />
                <YesNoChoice name="icann" title='domain_srs_tos_icann' />
                <Field name="termsAcceptance">
                  {({field, form, meta: { touched, error }}) => (
                    <div className={`formGroup${(touched && error) ? ' error' : ''}`}>
                      <div className='formField --checkbox'>
                        <div className='fieldTitle'>{t('Termini e condizioni')}</div>
                        <input type="checkbox" name={field.name} value={true} defaultChecked={field.value} onChange={field.onChange} />
                        <label dangerouslySetInnerHTML={{__html: t('altervista_tos_and_privacy')}}></label>
                      </div>
                      {touched && error && <div className="errorMessage">{error}</div>}
                    </div>
                  )}
                </Field>
              </section>
              <FormError />
              <section className='form-bottom-actions'>
                <button className='btn-form-default' type="submit">
                  {formikProps.isSubmitting
                    ? <Spinner />
                    : t('Scegli pagamento')
                  }
                </button>
              </section>
            </div>
          </div>
        </form>
      )}
    </Formik>
    )
  }} />
)
